import { useMutation } from '@tanstack/react-query'

import { useSharedDates } from '@contexts/sharedDates'
import { api } from '@services/apiClient'
import { queryClient } from '@services/queryClient'

import { useDate } from './dates'
import { useFindProfile } from './profile'

interface IScheduleFeedback {
  type: string
  exceptionEventTypeId: number
  changeType: string
  hoursToMove: number | null | undefined
  proposedStartTime: string | null | undefined
  comment: string
  taskDuration: number
}

interface IPostScheduleFeedback {
  scheduleFeedback: IScheduleFeedback
  id: number
}

export const useAddScheduleFeedbacks = () => {
  const { data: user } = useFindProfile()
  const { selectedDate } = useSharedDates()
  const { getWeekRange } = useDate()

  const { weekStart } = getWeekRange(selectedDate)

  const siteId = user && user.selectedSite.id

  const postScheduleFeedbacks = async ({
    id,
    scheduleFeedback,
  }: IPostScheduleFeedback) => {
    const url = `/sites/${siteId}/tasks/${id}/scheduleFeedbacks`
    const { data } = await api.post(url, scheduleFeedback)

    return data
  }

  return useMutation({
    mutationFn: postScheduleFeedbacks,
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['TASK'], type: 'active' })
      queryClient.refetchQueries({
        queryKey: ['TASKS', weekStart.getTime()],
        type: 'active',
      })
    },
  })
}
